import React, { useEffect, useState } from "react";
import { UserLayout } from "@/components/DashboardLayout";
import { api } from "@/lib/api";
import * as Lucide from "lucide-react";
import { toast } from "sonner";

export default function Affiliate() {
  const [data, setData] = useState(null);
  const [commissions, setCommissions] = useState([]);
  useEffect(() => {
    api.get("/affiliate/me").then((r) => setData(r.data));
    api.get("/affiliate/commissions").then((r) => setCommissions(r.data));
  }, []);

  const copy = async () => {
    if (!data?.share_url) return;
    await navigator.clipboard.writeText(data.share_url);
    toast.success("Referral link copied");
  };

  return (
    <UserLayout>
      <h1 className="bx-heading text-3xl font-extrabold">Affiliate Program</h1>
      <p className="text-slate-400 text-sm mt-1">Earn {data ? `${Math.round(data.rate * 100)}%` : "—"} lifetime commission on every credit purchase by users you refer.</p>

      <div className="grid lg:grid-cols-4 gap-4 mt-6">
        <div className="bx-card p-5">
          <div className="text-xs uppercase tracking-[0.2em] text-slate-500">Referrals</div>
          <div className="bx-heading mt-2 text-3xl font-extrabold">{data?.referrals_count || 0}</div>
        </div>
        <div className="bx-card p-5">
          <div className="text-xs uppercase tracking-[0.2em] text-slate-500">Pending</div>
          <div className="bx-heading mt-2 text-3xl font-extrabold text-amber-300">${(data?.earned_pending_usd || 0).toFixed(2)}</div>
        </div>
        <div className="bx-card p-5">
          <div className="text-xs uppercase tracking-[0.2em] text-slate-500">Paid Out</div>
          <div className="bx-heading mt-2 text-3xl font-extrabold text-emerald-400">${(data?.earned_paid_usd || 0).toFixed(2)}</div>
        </div>
        <div className="bx-card p-5">
          <div className="text-xs uppercase tracking-[0.2em] text-slate-500">Balance</div>
          <div className="bx-heading mt-2 text-3xl font-extrabold">${(data?.balance_usd || 0).toFixed(2)}</div>
        </div>
      </div>

      <div className="bx-card p-6 mt-6">
        <div className="bx-heading text-lg font-semibold">Your referral link</div>
        <div className="mt-3 flex flex-col sm:flex-row gap-3">
          <input data-testid="affiliate-share-url" value={data?.share_url || ""} readOnly className="bx-input flex-1 bx-mono text-xs" />
          <button data-testid="affiliate-copy" onClick={copy} className="bx-btn-primary"><Lucide.Copy size={16} /> Copy link</button>
        </div>
        <div className="text-xs text-slate-500 mt-3">Code: <span className="bx-mono text-purple-300">{data?.affiliate_code}</span></div>
      </div>

      <div className="mt-8">
        <div className="bx-heading text-lg font-semibold mb-3">Commission history</div>
        <div className="bx-card overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-white/5 text-xs uppercase tracking-wider text-slate-400">
              <tr><th className="text-left p-3">Date</th><th className="text-left p-3">Order amount</th><th className="text-left p-3">Rate</th><th className="text-right p-3">Commission</th><th className="text-right p-3">Status</th></tr>
            </thead>
            <tbody>
              {commissions.map((c) => (
                <tr key={c.id} className="border-t border-white/5">
                  <td className="p-3 text-slate-400">{new Date(c.created_at).toLocaleDateString()}</td>
                  <td className="p-3">${c.amount_usd.toFixed(2)}</td>
                  <td className="p-3">{Math.round((c.rate || 0) * 100)}%</td>
                  <td className="p-3 text-right font-mono text-emerald-400">${c.commission_usd.toFixed(2)}</td>
                  <td className="p-3 text-right"><span className="bx-chip" style={{ fontSize: 10 }}>{c.status}</span></td>
                </tr>
              ))}
              {!commissions.length && <tr><td colSpan={5} className="p-6 text-center text-slate-500">No commissions yet. Share your link!</td></tr>}
            </tbody>
          </table>
        </div>
      </div>
    </UserLayout>
  );
}
